import {useContext, useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/_BlockCS.module.scss";

import dynamic from 'next/dynamic';
import ErrorBlock from "../SchoolBlocks/ErrorBlock";
import {StoreContext} from "../../../stores/StoreLoader";

export const enum ITerraceTypes {
    EVENTS = "events",
    NEWS = "news",
    MEDIA = "media",
    ABOUT = "about",
    MAP = "map",
    HTML = "html",
    FILES = "files",
    HERO = "hero",
}

const blockTypes = {
    [ITerraceTypes.MAP]: dynamic(() => import("./MapBlock/MapBlock")),
    [ITerraceTypes.EVENTS]: dynamic(() => import("./EventsBlock/EventsBlock")),
    [ITerraceTypes.ABOUT]: dynamic(() => import("./AboutBlock/AboutBlock")),
    [ITerraceTypes.HTML]: dynamic(() => import("./HTMLBlock/HTMLBlock")),
    [ITerraceTypes.NEWS]: dynamic(() => import("./NewsBlock/NewsBlock")),
    [ITerraceTypes.MEDIA]: dynamic(() => import("./GalleryBlock/GalleryBlock")),
    [ITerraceTypes.FILES]: dynamic(() => import("./FilesFoldersBlock/FilesFoldersBlock")),
};

const Block = observer((props: {
    blockObj: ITerrace,
}) => {
    const {interfaceStore} = useContext(StoreContext);

    const [aboveTheFold, setAboveTheFold] = useState(false);
    const blockRef = useRef<HTMLElement | null>(null);

    const BlockTypeComponent = blockTypes[props.blockObj.type] || ErrorBlock;

    useEffect(() => {
        if (blockRef?.current) {
            const rect = blockRef.current?.getBoundingClientRect();
            if (rect.top < (window.innerHeight - window.innerHeight/4)) {
                setAboveTheFold(true);
            }
        }
    }, [interfaceStore.scrollPosition])

    const blockClassName = classNames({
        [styles.block]: true,
        [styles.blockAboveTheFold]: aboveTheFold,
        [styles.blockPadded]: props.blockObj.type !== ITerraceTypes.MAP,
    });

    return (
        <article
            className={blockClassName}
            data-id={props.blockObj.id}
            data-block-type={props.blockObj.type}
            ref={blockRef}
        >
            <BlockTypeComponent blockObj={props.blockObj} aboveTheFold={aboveTheFold} />
        </article>
    );
});

export default Block;
